var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AffiliateForm',{attrs:{"affiliate":_vm.affiliate,"buttonLoading":_vm.buttonLoading},on:{"saveAffiliate":_vm.saveAffiliate,"regenerateCode":_vm.generateAffiliateCode}})
}
var staticRenderFns = []

export { render, staticRenderFns }